<ion-header>
  <ion-toolbar #toolbar>
    <ion-buttons slot="start">
      <ion-button appClick (clicked)="onAbbrechen()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title><span id="page-title-span">{{ title | async | translate }}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="auftrag" class="section-content" #content>
  <div class="section">
    <h1>{{ position.Bezeichnung }}</h1>
    <h2 [class.rot]="restMenge" [class.gruen]="!restMenge">{{ istMenge }} von {{ sollMenge }} {{ position.Einheit }}</h2>
  </div>

  <div *ngFor="let p of chargen" class="section">
    <h1>NVE: {{ p.NVE }}</h1>

    <div *ngIf="p.restMengeZuGering" class="rest-menge-warnung">
      Die Rest-Menge ({{ p.restMenge }}) auf der Palette ist zu gering. Bitte weitere NVE scannen !!
    </div>

    <div>Charge: {{ p.Charge }}</div>
    <div>MHD: {{ p.MHD }}</div>

    <app-input-number titel="Menge"
                      lines="none"
                      type="integer"
                      einheit=""
                      [step]="1"
                      [readOnly]="false"
                      [plusMinusButtons]="true"
                      [anzahlNachkommastellen]="0"
                      [(ngModel)]="p.Menge"
                      (valueChanged)="onMengeChanged(p, $event)"></app-input-number>
  </div>

  <div class="section buttons-section">
    <ion-button appClick (clicked)="onSpeichern()" class="button-md button-border" expand="full" color="primary">OK</ion-button>
    <ion-button appClick (clicked)="onAbbrechen()" class="button-md button-border" expand="full" color="light">Abbrechen</ion-button>
  </div>


  <div class="section buttons-section buttons-section-normal" *ngIf="testButtonsAnzeigen">
    <h1>Simulation NVEs</h1>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00123456789012345678')" expand="full" color="light" class="status-button">
      NVE 1
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340026279217462900')" expand="full" color="light" class="status-button">
      NVE 2
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00140026279217462900')" expand="full" color="light" class="status-button">
      NVE 3
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340000000000000002')" expand="full" color="light" class="status-button">
      NVE 4 (Distelhäuser Pils 0,5l)
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340000000000000003')" expand="full" color="light" class="status-button">
      NVE, ARTNR: 512
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340000000000000004')" expand="full" color="light" class="status-button">
      NVE, ARTNR: 512 (Nr. 2)
    </ion-button>
  </div>

  <div class="footer-space"></div>
</ion-content>